var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.001,
    height: 35.992,
    viewBox: "0 0 36.001 35.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    "data-name": "Path 4063",
    d: "M-737.1,261.357a18.028,18.028,0,0,1-18.005-17.872,18.019,18.019,0,0,1,17.991-18.119,18.051,18.051,0,0,1,18.009,17.956A18.01,18.01,0,0,1-737.1,261.357Zm-1.63-22.9h0c0,1.6,0,3.194,0,4.791a1.638,1.638,0,0,0,.438,1.228q2.487,2.5,4.987,4.986a1.519,1.519,0,0,0,1.6.364,1.625,1.625,0,0,0,.63-2.747q-2.045-2.075-4.121-4.118a.851.851,0,0,1-.279-.669q.015-4.254,0-8.508a2.48,2.48,0,0,0-.192-1,1.592,1.592,0,0,0-1.81-.827,1.589,1.589,0,0,0-1.24,1.516C-738.744,235.134-738.733,236.794-738.733,238.455Z",
    transform: "translate(755.108 -225.365)",
    fill: "#253766"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.77def178f30527b4e54e99edcd57606c.svg";
export { ForwardRef as ReactComponent };